"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delegateTokenize = void 0;

var _tokenize = require("./../../tokenize");

const delegateTokenize = elements => class BasisTheoryTokenizesElementsDelegate extends _tokenize.BasisTheoryTokenize {
  tokenize(payload, requestOptions) {
    if (elements !== null && elements !== void 0 && elements.hasElement(payload)) {
      return elements.tokenize(payload, requestOptions);
    }

    return super.tokenize(payload, requestOptions);
  }

};

exports.delegateTokenize = delegateTokenize;